<template>
  <EUIPrimaryLayout>
    <template v-slot:header>
      <HeaderWidget />
    </template>
    <template v-slot:deault>
      <MenuDrawer />
    </template>
    <template v-slot:body>
      <router-view />
    </template>
    <template v-slot:footer>
      <InLifeFooterWidget />
    </template>
  </EUIPrimaryLayout>
</template>

<script>
import EUIPrimaryLayout from '@eui-template/primary-layout';

export default {
  name: 'PrimaryLayout',
  components: {
    EUIPrimaryLayout,
    MenuDrawer: () => import('../../../widgets/menu-drawer'),
    HeaderWidget: () => import('../../../widgets/header'),
    InLifeFooterWidget: () => import('../../../widgets/in-life-footer')
  }
};
</script>
